import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import cn from 'classnames'
import FormControl from '@material-ui/core/FormControl'
import TextField from '@material-ui/core/TextField'
import { onFormInputEnterPress } from 'helpers/input'
import { NUMBER_REG_EXP_PATTERN } from 'constants/regExps'

class EventResultNumberInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      evt_logbook_id: props.eventInfo.evt_logbook_id,
      previousValue: props.eventInfo.previous_value,
      value: props.eventInfo.value,
      oldValue: props.eventInfo.value,
    }
  }

  shouldComponentUpdate(nextProps) {
    if (this.props.eventInfo !== nextProps.eventInfo) {
      this.setState({
        evt_logbook_id: nextProps.eventInfo.evt_logbook_id,
        previousValue: nextProps.eventInfo.previous_value,
        value: nextProps.eventInfo.value,
        oldValue: nextProps.eventInfo.value,
      })

      return false
    }

    return true
  }

  setResultId = ({ id }) => {
    this.setState({
      evt_logbook_id: id,
    })
  }

  onInputChange = e => {
    const numberRegExp = new RegExp(NUMBER_REG_EXP_PATTERN)
    let value = e.target.value.trim()

    if (/^[-+]\.$/.test(value)) {
      value = `${value.substr(0, 1)}0.`
    }

    if (!numberRegExp.test(value)) {
      value = this.state.oldValue
    }

    this.setState({
      value,
      oldValue: value,
    })
  }

  onAutoSaveValue = () => {
    const { eventInfo, onValueChange } = this.props
    const digit = 10 ** (eventInfo ? eventInfo.parameters.decimals : 2)
    const { evt_logbook_id, oldValue } = this.state
    let { value } = this.state

    value = parseFloat(value)
    value = Number.isNaN(value) ? '' : Math.round(value * digit) / digit

    if (value === null || value === '') {
      this.setState({
        value: oldValue,
      })

      return
    }

    if (oldValue !== value) {
      this.setState(
        {
          value,
          oldValue: value,
        },
        () => {
          onValueChange({
            ...eventInfo,
            value: this.state.value,
            evt_logbook_id,
            setResultId: this.setResultId,
          })
        },
      )
    }
  }

  formatValue = value => (!value && value !== 0 ? '' : value)

  render() {
    const { tabIndex, dataIndex, disabled } = this.props
    const { value, previousValue } = this.state

    return (
      <FormControl>
        <TextField
          value={this.formatValue(value)}
          onBlur={this.onAutoSaveValue}
          onChange={this.onInputChange}
          autoFocus={dataIndex === 0}
          placeholder={String(this.formatValue(previousValue))}
          inputProps={{
            onKeyUp: onFormInputEnterPress,
            tabIndex,
            className: cn({ 'js-enter-press-input': !disabled }),
            'data-index': dataIndex,
          }}
          className="event-result-field event-result-input"
          disabled={disabled}
        />
      </FormControl>
    )
  }
}

export default injectIntl(EventResultNumberInput)
